import { fetchedSchema, FetchSchemaAction, mutatedSchema, MutateSchemaAction } from "actions/merchant/merchant-schema";
import { add as snackbarAdd } from "actions/snackbars";
import { MERCHANT } from "constants/action-types";
import { getSchemaByType } from "helpers/merchant/merchant-schema";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import { ActionsObservable } from "redux-observable";
import { Observable } from "rxjs";
import siteConfig from "site-config";

export const fetchMerchantSchemasEpic = (action$: ActionsObservable<FetchSchemaAction>, store) =>
    action$
        .ofType(MERCHANT.SCHEMA.FETCH)
        .map(({ payload }) => payload)
        .switchMap(({ merchantId, schemaType }) => {
            return ajax(`${siteConfig.goAPI}/v1/collections/merchants/${merchantId}/item_display_properties`)
                .flatMap(({ response, status }) => {
                    if (status !== 200) {
                        throw new Error(response.message || formatMessage("Unknown fetch error"));
                    }

                    const schema = getSchemaByType(response.data ?? []);

                    if (!schema) {
                        throw new Error("Schema not found");
                    }
                    return [fetchedSchema(schema)];
                })
                .catch((error) => Observable.merge(Observable.of(fetchedSchema(error))));
        });

export const mutateMerchantSchemasEpic = (action$: ActionsObservable<MutateSchemaAction>, store) =>
    action$
        .ofType(MERCHANT.SCHEMA.MUTATE)
        .map(({ payload }) => payload)
        .switchMap(({ merchantId, schemaId, schema }) => {
            const {
                merchantSchema: { result },
            } = store.getState();
            const merchantItemDisplayProperty = { ...result };
            merchantItemDisplayProperty.display_property = schema;
            return ajax({
                method: "PUT",
                url: `${siteConfig.goAPI}/v1/collections/merchants/${merchantId}/item_display_properties/${schemaId}`,
                body: {
                    merchant_item_display_property: merchantItemDisplayProperty,
                    update_mask: {
                        paths: ["name", "display_property"],
                    },
                },
            })
                .flatMap(({ response }) => {
                    return [mutatedSchema(response), snackbarAdd({ message: formatMessage("Schema updated") })];
                })
                .catch((error) =>
                    Observable.merge(
                        Observable.of(mutatedSchema(error)),
                        Observable.of(snackbarAdd({ message: error.message || formatMessage("Error saving") }))
                    )
                );
        });
